module.exports = __webpack_public_path__ + "static/media/CROWN-WP-2.4b7ae74f.jpg";